export type LocaleCode = 'nl' | 'en'

export interface LocaleOption {
  label: string
  value: LocaleCode
}

export const SUPPORTED_LOCALES: LocaleCode[] = [ 'nl', 'en' ]

export const LOCALE_OPTIONS: LocaleOption[] = [
  {
    label: 'Nederlands',
    value: 'nl',
  },
  {
    label: 'English',
    value: 'en',
  },
]

export const DEFAULT_LOCALE: LocaleCode = 'nl'
